import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppearanceAnimation, ButtonLayoutDisplay, ButtonMaker, DialogBelonging, DialogInitializer, DialogLayoutDisplay, DisappearanceAnimation } from '@costlydeveloper/ngx-awesome-popup';
import { DialogStartCashRegisterComponent } from '../dialog-start-cash-register/dialog-start-cash-register.component';
import { CashRegisterService } from 'src/app/services/cash-register.service';
import { MatDialogModule } from "@angular/material/dialog";
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-dialog-continue-session',
  standalone: true,
  templateUrl: './dialog-continue-session.component.html',
  styleUrls: ['./dialog-continue-session.component.scss'],
  imports: [MatDialogModule, FontAwesomeModule]
})
export class DialogContinueSessionComponent implements OnInit {
  private data: any;
  faTimes = faTimes;
  id_business: any;

  constructor(@Inject('dialogBelonging') public dialogBelonging: DialogBelonging, private router: Router, private cashRegisterService: CashRegisterService) { }

  ngOnInit(): void {
    this.data = this.dialogBelonging;
    this.id_business = localStorage.getItem('id_business');
  }

  continueSession() {
    this.router.navigate(['/home']);
    localStorage.setItem('cash_register_name', this.data.customData.cash_name)
    localStorage.setItem('id_cash_register', this.data.customData.id_cash_register)
    this.dialogBelonging.eventsController.close();

  }
  newSession() {

    this.cashRegisterService.closeWorkTime(this.id_business, Number(this.data.customData.id_cash_register)).subscribe(response => {
      if (response) {
        const dialogPopup = new DialogInitializer(DialogStartCashRegisterComponent);

        // Any data can be sent to AnyAngularComponent.
        dialogPopup.setCustomData(this.data.customData);

        // Set some configuration.
        dialogPopup.setConfig({
          width: '500px',
          layoutType: DialogLayoutDisplay.NONE, // SUCCESS | INFO | NONE | DANGER | WARNING
          animationIn: AppearanceAnimation.NONE,
          animationOut: DisappearanceAnimation.NONE,
          escapeKeyClose: true,

        });

        // Set some custom buttons as list.
        // SUCCESS | INFO | NONE | DANGER | WARNING | PRIMARY | SECONDARY | LINK | DARK | LIGHT
        dialogPopup.setButtons([
          new ButtonMaker('Cancelar', 'cancel', ButtonLayoutDisplay.SECONDARY),
          new ButtonMaker('Confirmar', 'submit', ButtonLayoutDisplay.SUCCESS)
        ]);

        // Simply open the popup and observe which button is clicked and, 
        // receive optional payload from AnyAngularComponent.
        dialogPopup.openDialog$().subscribe(resp => {

          this.dialogBelonging.eventsController.close();
        });
      }
    })
  }

  closeDialog() {
    this.dialogBelonging.eventsController.close();
  }

}
